import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { glassCardStyle } from "@/components/auth/authStyles";

export function ApplicationFormSkeleton() {
  return (
    <div className="min-h-screen py-8" style={{ background: "var(--landing-bg)" }}>
      <div className="container">
        <div className="mx-auto max-w-5xl">
          <Skeleton className="h-9 w-20 mb-8" />
          <Skeleton className="h-8 w-64 mb-8" />
          <Card className="mb-8 rounded-2xl" style={glassCardStyle}>
            <CardContent className="p-6">
              <div className="flex items-center justify-between mb-4">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-2 flex-1 mx-4 rounded-full" />
              </div>
              <div className="flex gap-2">
                <Skeleton className="h-8 w-24 rounded-full" />
                <Skeleton className="h-8 w-20 rounded-full" />
                <Skeleton className="h-8 w-16 rounded-full" />
              </div>
            </CardContent>
          </Card>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2 space-y-6">
              <Card style={glassCardStyle}>
                <CardContent className="p-5 sm:p-10">
                  <div
                    className="border-2 border-dashed rounded-2xl p-6 sm:p-10 flex flex-col items-center justify-center gap-3"
                    style={{ borderColor: "var(--landing-glass-border)" }}
                  >
                    <Skeleton className="h-14 w-14 rounded-full" />
                    <Skeleton className="h-4 w-48" />
                    <Skeleton className="h-4 w-32" />
                  </div>
                </CardContent>
              </Card>
            </div>
            <div>
              <Card style={glassCardStyle}>
                <CardContent className="p-6 space-y-4">
                  <Skeleton className="h-6 w-32" />
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-4/5" />
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
